import { render } from "./BlogList.vue?vue&type=template&id=786baf2c&ts=true"
import script from "./BlogList.vue?vue&type=script&lang=ts"
export * from "./BlogList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__